import { render, staticRenderFns } from "./CompareTextContent.vue?vue&type=template&id=891a42e8"
import script from "./CompareTextContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareTextContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareTextContent.vue?vue&type=style&index=0&id=891a42e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports